import { Component, DestroyRef, Inject, ViewChild, inject, ElementRef, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface ProductData {
  id: any;
  so_id: any;
  event_id: any;
}

export interface ElementData {
  id: string;
  srNo: string;
  image_name: any;
  product_title: string;
  price: string;
  category: string;
  so_id: string;
  action: any;
}

@Component({
  selector: 'app-stall-product',
  templateUrl: './stall-product.component.html',
  styleUrls: ['./stall-product.component.scss']
})
export class StallProductComponent {
  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  @Input() so_id: any;
  displayedColumns: string[] = [
    'srNo',
    'image_name',
    'product_title',
    'price',
    'category',
    'action',
  ];

  ELEMENT_DATA: ElementData[] = [];
  event_result: any;
  id: any;
  event_id: any
  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<ElementData>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
  ) { }

  ngAfterViewInit() {
    // Get so_id from URL
    if (!this.so_id) {
      this.so_id = this.route.snapshot.paramMap.get('so_id');
    }
    console.log(this.so_id);
    this.Get_Products(this.so_id);
    this.dataSource.paginator = this.paginator;
  }

  AddProduct() {
    const dialogRef = this.dialog.open(add_edit_product, {
      data: {
        id: this.id,
        so_id: this.so_id,
        event_id: this.event_id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Products(this.so_id);
    });
  }

  EditProduct(id: any) {
    const dialogRef = this.dialog.open(add_edit_product, {
      data: {
        id: id,
        so_id: this.so_id,
        event_id: this.event_id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Products(this.so_id);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_Products(so_id: any) {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_products(so_id).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.event_id = data.event_id;
        this.event_result = data.data;
        this.ELEMENT_DATA = this.event_result.map((item: { id: any; event_id: any, image_name: any; product_title: any; price: any; category: any, so_id: any; }, index: number) => ({
          srNo: index + 1,
          id: item.id,
          image_name: `https://aieventzo.com/upload/` + item.event_id + `/stall_product/` + item.image_name,
          product_title: item.product_title,
          price: item.price,
          category: item.category,
          so_id: item.so_id,
          action: item.id
        })
        );
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<ElementData>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  DeleteProduct(id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Product?');
    if (buttonClicked === true) {
      this.service.delete_product(id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.id !== id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Product Deleted Succesfully");
        });
    }
  }

  goToProductQr(so_id: any) {
    console.log(so_id);
    sessionStorage.setItem('so_id', so_id);
    this.router.navigate(['admin/Product QR/' + so_id]);
  }
}


@Component({
  selector: 'add_edit_product',
  templateUrl: './add_edit_product.html',
  styleUrls: ['./stall-product.component.scss'],
  standalone: false
})
export class add_edit_product {

  StallForm: FormGroup;
  so_id: any
  result: any;
  private destoryRef = inject(DestroyRef);
  owner_data: any;
  event_id: any;
  product_title: any;
  product_link: any;
  price: any;
  offer_price: any;
  description: any;
  category_id: any;
  id: any;
  message!: string;
  imagefileURL!: any | ArrayBuffer;
  imagePath: any;
  isOld1: boolean = false;
  image_name: any;
  category_result: any;

  constructor(
    private member: FormBuilder,
    private service: ServicesService,
    private dialogRef: MatDialogRef<add_edit_product>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: ProductData
  ) {
    this.id = data['id'];
    this.so_id = data['so_id'];
    this.event_id = data['event_id'];

    this.StallForm = this.member.group({
      id: this.id,
      so_id: this.so_id,
      category_id: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      stall_id: new FormControl(''),
      image_name: new FormControl(''),
      product_title: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      product_link: new FormControl('', [Validators.pattern(/^(\s*\S+\s*)+$/),]),
      price: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      offer_price: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      description: new FormControl(''),
      youtube: new FormControl(''),
      facebook: new FormControl(''),
      instagram: new FormControl(''),
      notes: new FormControl('')
    });

  }


  get_category() {
    this.service.get_category(this.so_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
      (data: any) => {
        this.category_result = data.data

      },
      error => {
        this.toastr.error('Failed to load users');
      }
    );
  }

  ngOnInit(): void {
    console.log(this.event_id);
    this.get_product_by_id(this.id);
    this.get_category();
  }

  get_product_by_id(id: any) {
    this.service.get_product_by_id(id).subscribe(
      (data: any) => {
        this.owner_data = data.data;
        this.category_id = this.owner_data[0].category_id;
        this.image_name = this.owner_data[0].image_name;
        this.product_title = this.owner_data[0].product_title;
        this.product_link = this.owner_data[0].product_link;
        this.price = this.owner_data[0].price;
        this.offer_price = this.owner_data[0].offer_price;
        this.description = this.owner_data[0].description;
      });
    this.isOld1 = true;

  }

  previewpimage(files: any) {
    console.log(files);
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.service.uploadimage(this.imagefileURL, this.event_id + "/stall_product").subscribe((data: any) => {
        this.imagePath = data['image_name'];
        console.log(this.imagePath);
        this.isOld1 = false;
        this.StallForm.patchValue({
          image_name: this.imagePath
        })
      });
    };
  }

  onFormSubmit() {

    const formData = this.StallForm.value;
    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.StallForm.valid && hasNonEmptyField) {
      const ExistedImage = this.isOld1 ? this.image_name : this.imagePath;
      console.log(ExistedImage);

      this.StallForm.patchValue({
        image_name: ExistedImage
      })

      if (this.id) {
        this.service.edit_product(this.StallForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            this.toastr.success("Product Updated Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.service.add_product(this.StallForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            this.toastr.success("Product Added Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}